"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isFunction(fn) {
  return typeof fn === 'function';
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

function isFSA(action) {
  return action !== null && _typeof(action) === 'object' && typeof action.type === 'string' && Object.keys(action).every(isValidKey);
}

function createThunkMiddleware() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function processAction(action) {
        if (isFunction(action)) {
          var nextStep = action(dispatch, getState, opts.extraArgument);
          return opts.next ? processAction(nextStep) : nextStep;
        }

        if (isFSA(action) && isFunction(action.payload)) {
          var _nextStep = action.payload(dispatch, getState, opts.extraArgument);

          if (_nextStep === null && opts.interrupt) {
            return _nextStep;
          }

          return next(_objectSpread(_objectSpread({}, action), {}, {
            payload: _nextStep
          }));
        } // do not pass on empty action


        if (opts.interrupt && (action === null || action === undefined)) {
          return action;
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();

thunk.withExtraArgument = function (extraArgument) {
  return createThunkMiddleware({
    extraArgument: extraArgument
  });
};

thunk.withOpts = createThunkMiddleware;
var _default = thunk;
exports.default = _default;